<template>
    <div>
        <div class="ppv2-flex ppv2-items-center ppv2-gap-2 ppv2-mb-3">
            <span class="ppv2-text-[11px] poppinsBold ppv2-uppercase ppv2-tracking-[0.67px] ppv2-text-[#A78BFA]">
                {{ $t('staff_planning_v3.components.staff_selector.show_for') }}
            </span>

            <div
                class="ppv2-w-5 ppv2-h-5 ppv2-rounded-full ppv2-bg-[#7C3AED] ppv2-text-white ppv2-text-[11px] poppinsSemiBold ppv2-flex ppv2-items-center ppv2-justify-center"
            >
                {{ selected ? selected.length : 0 }}
            </div>
        </div>

        <div class="ppv2-border ppv2-border-black ppv2-border-opacity-[8%] ppv2-rounded-xl ppv2-overflow-hidden">
            <div
                v-for="staff in staffs"
                :key="staff.value"
                class="ppv2-flex ppv2-items-center ppv2-gap-4 ppv2-px-4 ppv2-py-3 ppv2-border-b ppv2-bg-black ppv2-bg-opacity-[3%] last:ppv2-border-b-0 ppv2-border-black ppv2-border-opacity-[8%]"
            >
                <BaseCheckbox
                    :value="selected.includes(staff.value)"
                    @input="toggleStaff(staff.value, $event)"
                    size="md"
                    has-border-checked
                />

                <div
                    class="ppv2-w-10 ppv2-h-10 ppv2-rounded-full ppv2-bg-white dark:ppv2-bg-dark-popup ppv2-flex ppv2-items-center ppv2-justify-center poppinsMedium"
                >
                    {{ staff.label.charAt(0).toUpperCase()
                    }}{{ staff.label.split(' ').length > 1 ? staff.label.split(' ')[1].charAt(0).toUpperCase() : '' }}
                </div>

                <div class="ppv2-flex-1">
                    <div class="ppv2-text-sm poppinsMedium ppv2-text-black poppinsMedium">
                        {{ staff.label }}
                    </div>

                    <div class="ppv2-text-xs ppv2-text-gray-500 poppinsRegular">
                        {{ capitalizeFirst(staff.type) }}
                    </div>
                </div>

                <div class="ppv2-text-sm poppinsMedium ppv2-text-black poppinsMedium">{{ staff.total }}</div>
            </div>
        </div>

        <div class="ppv2-flex ppv2-justify-end ppv2-mt-2">
            <button
                @click="canDeselect ? deselectAll() : selectAll()"
                class="ppv2-text-sm ppv2-text-gray-400 hover:ppv2-text-[#7C3AED] poppinsRegular ppv2-underline"
            >
                {{ canDeselect ? $t('staff_planning_v3.main.deselect_all') : $t('staff_planning_v3.main.select_all') }}
            </button>
        </div>
    </div>
</template>

<script>
import BaseCheckbox from '../../../Shared/BaseCheckbox.vue'

export default {
    components: {
        BaseCheckbox,
    },
    props: {
        staffs: {
            type: Array,
            default: () => [],
        },
        selected: {
            type: Array,
            default: () => [],
        },
    },

    computed: {
        canDeselect() {
            return (this.selected || []).length >= 2
        },
    },

    methods: {
        capitalizeFirst(str) {
            if (!str) return ''
            return str.charAt(0).toUpperCase() + str.slice(1)
        },
        toggleStaff(staffId, val) {
            let newSelected = [...(this.selected || [])]
            if (val) {
                if (!newSelected.includes(staffId)) newSelected.push(staffId)
            } else {
                newSelected = newSelected.filter((id) => id !== staffId)
            }
            this.$emit('update:selected', newSelected)
        },
        selectAll() {
            this.$emit(
                'update:selected',
                this.staffs.map((s) => s.value)
            )
        },
        deselectAll() {
            this.$emit('update:selected', [])
        },
    },
}
</script>
